__turbopack_context__.v({
  "addButton": "3d-generation-module__zTFchq__addButton",
  "backendSelector": "3d-generation-module__zTFchq__backendSelector",
  "downloadLink": "3d-generation-module__zTFchq__downloadLink",
  "errorAlert": "3d-generation-module__zTFchq__errorAlert",
  "formItem": "3d-generation-module__zTFchq__formItem",
  "generationContainer": "3d-generation-module__zTFchq__generationContainer",
  "inventoryButton": "3d-generation-module__zTFchq__inventoryButton",
  "loading": "3d-generation-module__zTFchq__loading",
  "optionsContainer": "3d-generation-module__zTFchq__optionsContainer",
  "optionsToggle": "3d-generation-module__zTFchq__optionsToggle",
  "previewImage": "3d-generation-module__zTFchq__previewImage",
  "responseJson": "3d-generation-module__zTFchq__responseJson",
  "result": "3d-generation-module__zTFchq__result",
  "resultTitle": "3d-generation-module__zTFchq__resultTitle",
  "root": "3d-generation-module__zTFchq__root",
  "subtitle": "3d-generation-module__zTFchq__subtitle",
  "title": "3d-generation-module__zTFchq__title",
});
